/* eslint-disable max-len */
import React from 'react';
import { Lightbox } from './lightbox';

interface Props {
  images: any;
}

function Component(props: Props) {
  //
  const { images } = props;

  return (
    <div className="grid w-full gap-4 lg:grid-cols-3 md:grid-cols-2">
      {images.map((image: any) => (
        <Lightbox
          key={image.id}
          body={image.body}
          imageData={image.imageData}
          title={image.title}
        />
      ))}
    </div>
  );
}

export const ImageRenderer = Component;
